module.exports = __webpack_public_path__ + "static/media/caddie_icon_b.02500e90.png";